// removed by extract-text-webpack-plugin
module.exports = {"linchen-shape":"linchen-shape","flash":"flash"};


//////////////////
// WEBPACK FOOTER
// ./src/pubBiz/FrameWork/Shape/index.less
// module id = 891
// module chunks = 367